import { render } from "./sales-report.vue?vue&type=template&id=4b6ce14e&scoped=true"
import script from "./sales-report.vue?vue&type=script&lang=js"
export * from "./sales-report.vue?vue&type=script&lang=js"

import "./sales-report.vue?vue&type=style&index=0&id=4b6ce14e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6ce14e"]])

export default __exports__